import { useAuth } from '../../auth/AuthProvider';
import { MfaPanel } from '../../components/MfaPanel';

/** Account section: the signed-in user's profile and multi-factor authentication. */
export function ProfileSettings(): JSX.Element {
  const { me } = useAuth();
  return (
    <>
      <div className="card">
        <h2>Profile</h2>
        <p>
          {me?.displayName} · {me?.permissions?.length ?? 0} permissions
          {me?.isPlatformAdmin ? ' · platform admin' : ''}
        </p>
      </div>
      <MfaPanel />
    </>
  );
}
